var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visability('image'))?_c('div',{staticClass:"preview-image-element position-relative z-100 p-[2px]"},[_c('TemplateV2',{attrs:{"section":_vm.section}},[_c('div',{staticClass:"relative"},[_c('image-fit-v2',{attrs:{"customs":_vm.section.options.content.image}}),_vm._t("default")],2)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }